import { AppToolbar, StatusBar, registerIcons } from '../lib/index.js';

// Register app-specific icons
registerIcons({
    folder: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"/></svg>',
    upload: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
    extract: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>',
    analyze: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 20V10"/><path d="M18 20V4"/><path d="M6 20v-4"/></svg>',
    columns: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="9" y1="3" x2="9" y2="21"/><line x1="15" y1="3" x2="15" y2="21"/></svg>',
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>',
    retry: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg>',
    eyeOff: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>',
    eye: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>',
});

const ALL_GROUP_IDS = ['project', 'actions', 'view', 'info'];

const TAB_GROUPS = {
    dashboard: ['project'],
    howto: [],
    candidates: ['project', 'actions', 'view', 'info'],
    config: ['project'],
    criteria: [],
    emails: [],
    admin: [],
};

export class ResumeToolbar {
    constructor(container, options = {}) {
        this._onAction = options.onAction || (() => {});

        this._appToolbar = new AppToolbar(container, {
            groups: [
                { id: 'project', items: [
                    { id: 'openProject', icon: 'folder', title: 'Open Project' },
                    { type: 'label', id: 'projectName', className: 'toolbar-project-name' },
                ]},
                { id: 'actions', items: [
                    { id: 'extractAll', icon: 'extract', title: 'Extract All Info' },
                    { id: 'runAnalysis', icon: 'analyze', title: 'Run Analysis' },
                    { id: 'retryFailed', icon: 'retry', title: 'Retry Failed' },
                    { id: 'deleteSelected', icon: 'trash', title: 'Delete Selected' },
                ]},
                { type: 'spacer' },
                { id: 'view', items: [
                    { id: 'hideRejected', icon: 'eyeOff', title: 'Hide/Show Rejected' },
                    { id: 'toggleColumns', icon: 'columns', title: 'Toggle Columns' },
                ]},
                { id: 'info', items: [
                    { type: 'label', id: 'candidateCount' },
                ]},
            ],
            onButtonClick: (id) => this._onAction(id),
        });

        this._statusBar = new StatusBar(container, {
            onToggleToolbar: () => this._appToolbar.toggle(),
        });
    }

    get statusBar() { return this._statusBar; }

    setProjectName(name) {
        this._appToolbar.setLabel('projectName', name || '');
    }

    setCandidateCount(visible, total) {
        this._appToolbar.setLabel('candidateCount',
            visible === total ? `${total} candidates` : `${visible}/${total} candidates`);
    }

    showButtonsForTab(tabId) {
        const visible = TAB_GROUPS[tabId] || [];
        for (const gid of ALL_GROUP_IDS) {
            const el = this._appToolbar.getGroup(gid);
            if (el) el.style.display = visible.includes(gid) ? '' : 'none';
        }
    }

    getButton(id) { return this._appToolbar.getButton(id); }
}
